<template>
  <div class="pro-player">
    <div class="pro-player_wrap container">
      <PagesProPlayerComponentsPlayerInfo :info="info" />

      <div
        v-if="isLoading"
        class="load_period loading-container mt-10"
      >
        <div class="f fc">
          <i class="i-loading ml10" />
        </div>
      </div>
      <div v-else-if="items.length">
        <div class="f fs gap12 mb24">
          <svg
            class="light"
            height="24"
            width="24"
          >
            <use xlink:href="/icons/sprite.svg#i-soldier" />
          </svg>
          <h2>CS2 {{ t('Skins') }}</h2>
        </div>
        <div
          id="inventory"
          class="fg pro-player-items"
        >
          <div
            :class="{ compressed }"
            class="items-grid"
          >
            <!--            <LazyPagesWeaponComponentsSkinCard -->
            <!--                v-for="item in items" -->
            <!--                :key="item?.market_hash_name" -->
            <!--                :item="item" -->
            <!--                :link="getItemLinkWithExterior({ -->
            <!--                    name: item?.market_hash_name || '', -->
            <!--                    slug: item?.link -->
            <!--                  })" -->
            <!--            ></LazyPageWeaponComponentsSkinCard> -->
            <LazyPagesProPlayerComponentsItemCard
              v-for="item in items"
              :key="item?.market_hash_name"
              :item="item"
              :link="getItemLinkWithoutExt({ name: item?.market_hash_name, slug: item?.link })"
            />
          </div>

          <PaginateV3
            v-if="pagesLength > 1"
            key="paginate"
            :pages-length="pagesLength"
            :total="total"
            :total-items="total < (10 * (route.query.page || 1)) ? total : 10 * (route.query.page || 1)"
            use-query
          />
        </div>
        <LazyUiNoResult
          v-if="!isLoading && !items?.length"
          class="mxa"
        />
      </div>

      <div
        v-if="info.gears?.length"
        id="hardware"
        class="pro-player__hardware"
      >
        <div class="hardware-title f fs gap8 mb20">
          <svg
            height="28"
            width="28"
          >
            <use xlink:href="/icons/sprite.svg#i-hardware" />
          </svg>
          <h2>
            {{ t('hardware') }}
          </h2>
        </div>
        <div class="hardware-items">
          <Hardware
            v-for="hardware in computedGears || []"
            :key="hardware?.name"
            :item="hardware"
          />
        </div>

        <PaginateV3
          v-if="Math.round((info.gears?.length || 0) / limit) > 1"
          v-model="page"
          :pages-length="Math.round((info.gears?.length || 0) / limit)"
          :total="info.gears?.length || 0"
          :total-items="(info.gears?.length || 0) > limit * page
            ? limit * page
            : (info.gears?.length || 0)
          "
        />
      </div>
      <Configs :info="info" />

      <div
        v-if="teamsPlayers?.length"
        id="hardware"
        class="pro-player__hardware"
      >
        <div class="hardware-title f fs gap8 mb20">
          <svg
            height="28"
            width="28"
          >
            <use xlink:href="/icons/sprite.svg#community" />
          </svg>
          <h2>
            {{ t('teammates') }}
          </h2>
        </div>
        <div class="hardware-items">
          <PlayerCard
            v-for="player in filteredTeammates"
            :key="player.id"
            :player="player"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  AdvancedSearchBody,
  ProPlayer,
  ProPlayerWithItems,
} from '~/graphql/generated/schema-types';
import Configs from '~/components/Pages/ProPlayer/Components/Configs.vue';
import Hardware from '~/components/Pages/Team/Components/Hardware.vue';
import PlayerCard from '~/components/Pages/Team/Components/PlayerCard.vue';
import { useCompressed } from '~/composables/items-compressed';

const props = defineProps<{
  isLoading: boolean
  items: AdvancedSearchBody[]
  info: ProPlayerWithItems
  pagesLength: number
  total: number
  teamsPlayers?: ProPlayer[]
}>();

const { t } = useI18n();
const route = useRoute();
const { compressed } = useCompressed();
const page = ref(1);
const limit = ref(12);

const computedGears = computed(() => {
  return (props.info.gears || []).slice((page.value - 1) * limit.value, page.value * limit.value);
});
const filteredTeammates = computed(() => {
  return (props.teamsPlayers?.filter((player) => {
    return player.general?.nick_name !== props.info.general?.nick_name;
  }) || []) as ProPlayer[];
});
</script>

<style lang="scss" scoped>
.pro-player {
  &_wrap {
    margin-top: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 4.8rem;
    padding-bottom: 50px;

    @media screen and (max-width: 1250px) {
      margin-top: 0;
    }
  }

  &__hardware {
    .hardware-items {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(auto-fill, minmax(185px, 1fr));

      .card {
        padding: 16px;
      }

      @media screen and (max-width: 768px) {
        gap: 12px;
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      }
    }
  }

  .items-grid {
    width: 100%;
    gap: 16px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    justify-content: center;

    @media screen and (max-width: 1115px) {
      justify-content: center;
    }
    @media screen and (max-width: 979px) {
      gap: 2rem;
    }
    @media screen and (max-width: 768px) {
      //&.compressed {
      //  gap: 10px;
      //  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      //}
    }
    @media screen and (max-width: 625px) {
      gap: 1.2rem;
    }
  }
}

@media screen and (max-width: 1075px) {
  .pro-player {
    .pro-player_wrap {
      gap: 4rem;
    }
  }
}

@media screen and (max-width: 979px) {
  .pro-player-items {
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media screen and (max-width: 768px) {
  .pro-player {
    .pro-player_wrap {
      gap: 4rem;
    }

    .fg {
      width: 100%;
    }

    .wrapper {
      flex-direction: column;
    }
  }
}

@media screen and (max-width: 525px) {
  .pro-player {
    //.pro-player_wrap {
    //  gap: 1.6rem;
    //}
    .pro-player-items {
      padding-right: 0;
      padding-left: 0;
    }
  }
}
</style>
